/* import __COLOCATED_TEMPLATE__ from './oauth-banner.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import type IntlService from 'embercom/services/intl';
import { trackedInLocalStorage } from 'ember-tracked-local-storage';

const HIDE_IN_ROUTES = [
  'apps.app.loading',
  'apps.app.copilot-frame',
  'apps.app.settings.standalone.integration',
  'apps.app.standalone.deploy.zendesk.tickets.integrate',
  'apps.app.standalone.deploy.zendesk.messaging.integrate',
  'apps.app.standalone.deploy.intercom-messenger.integrate',
];

export const BANNER_KEY = 'zendesk-oauth-banner';

export interface Signature {
  Args: {
    onClick?: () => void;
    showInline?: boolean;
  };
  Blocks: {};
  Element: null;
}

export default class StandaloneZendeskOauthBanner extends Component<Signature> {
  @service declare appService: {
    mainStandalonePlatform: {
      showOauthBanner: boolean;
    };
    app: $TSFixMe;
  };
  @service declare router: RouterService;
  @service declare intl: IntlService;
  @trackedInLocalStorage({ keyName: BANNER_KEY }) bannerDismissedAt: number | undefined = undefined;

  get app() {
    return this.appService.app;
  }

  get standalonePlatform() {
    return this.appService.mainStandalonePlatform;
  }

  get shouldShowBanner(): boolean {
    if (!this.args.showInline && HIDE_IN_ROUTES.includes(this.router.currentRouteName)) {
      return false;
    }

    if (this.standalonePlatform.showOauthBanner) {
      return !this.bannerDismissedAt;
    }

    return false;
  }

  @action
  hideBanner() {
    this.bannerDismissedAt = Date.now();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Zendesk::OauthBanner': typeof StandaloneZendeskOauthBanner;
    'standalone/zendesk/oauth-banner': typeof StandaloneZendeskOauthBanner;
  }
}
